import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import useRouter from "utils/useRouter";
import checkProperBallotId from "utils/checkProperBallotId";
export default function withAuth(ComponentToProtect) {
  return class extends Component {
    constructor() {
      super();
      this.state = {
        loading: true,
        redirect: false,
      };
    }
    componentDidMount() {
      let isDifferentBallotId = checkProperBallotId();
      if (isDifferentBallotId) {
        Cookies.set("ballot_id", sessionStorage.getItem("forthistabballotid"));
        Cookies.set(
          "ballot_name",
          sessionStorage.getItem("forthistabballotname")
        );
      }
      if (Cookies.get("customer_id")) {
        this.setState({ loading: false });
      } else {
        this.setState({ loading: false, redirect: true });
      }
      this.setState({ loading: false });
    }
    render() {
      const { loading, redirect } = this.state;
      if (loading) {
        return null;
      }
      if (redirect) {
        return <Redirect to="/auth/login" />;
      }
      return (
        <React.Fragment>
          <ComponentToProtect {...this.props} />
        </React.Fragment>
      );
    }
  };
}
